export default __webpack_public_path__ + "static/media/loadingSpinners.5e19a98e.gif";